import { render, staticRenderFns } from "./ready.vue?vue&type=template&id=862bb24a&scoped=true&"
import script from "./ready.vue?vue&type=script&lang=js&"
export * from "./ready.vue?vue&type=script&lang=js&"
import style0 from "./ready.vue?vue&type=style&index=0&id=862bb24a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862bb24a",
  null
  
)

export default component.exports